var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 6.8625C6.875 6.69674 6.94085 6.53777 7.05806 6.42056C7.17527 6.30335 7.33424 6.2375 7.5 6.2375C7.66576 6.2375 7.82473 6.30335 7.94194 6.42056C8.05915 6.53777 8.125 6.69674 8.125 6.8625V10.6125C8.125 10.7783 8.05915 10.9372 7.94194 11.0544C7.82473 11.1717 7.66576 11.2375 7.5 11.2375C7.33424 11.2375 7.17527 11.1717 7.05806 11.0544C6.94085 10.9372 6.875 10.7783 6.875 10.6125V6.8625ZM7.5 3.78188C7.33424 3.78188 7.17527 3.84772 7.05806 3.96493C6.94085 4.08214 6.875 4.24112 6.875 4.40688C6.875 4.57264 6.94085 4.73161 7.05806 4.84882C7.17527 4.96603 7.33424 5.03188 7.5 5.03188C7.66576 5.03188 7.82473 4.96603 7.94194 4.84882C8.05915 4.73161 8.125 4.57264 8.125 4.40688C8.125 4.24112 8.05915 4.08214 7.94194 3.96493C7.82473 3.84772 7.66576 3.78188 7.5 3.78188Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1.25C4.04813 1.25 1.25 4.04813 1.25 7.5C1.25 10.9519 4.04813 13.75 7.5 13.75C10.9519 13.75 13.75 10.9519 13.75 7.5C13.75 4.04813 10.9519 1.25 7.5 1.25ZM2.5 7.5C2.5 8.82608 3.02678 10.0979 3.96447 11.0355C4.90215 11.9732 6.17392 12.5 7.5 12.5C8.82608 12.5 10.0979 11.9732 11.0355 11.0355C11.9732 10.0979 12.5 8.82608 12.5 7.5C12.5 6.17392 11.9732 4.90215 11.0355 3.96447C10.0979 3.02678 8.82608 2.5 7.5 2.5C6.17392 2.5 4.90215 3.02678 3.96447 3.96447C3.02678 4.90215 2.5 6.17392 2.5 7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.21d25660853352b7164fca4e2d17b970.svg";
export { ForwardRef as ReactComponent };